'use client'

import { Image } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { clickEvent } from '@marketplace-web/marketing-campaigns/marketing-landing-page-data'

import { HELP_CENTER_LINK, KEEP_SELLING_LINK } from '../../constants'
import { QuestionsSectionModel } from '../../types'

const Links = {
  0: HELP_CENTER_LINK,
  1: KEEP_SELLING_LINK,
}
type Props = { props: QuestionsSectionModel }

const QuestionsSection = ({ props }: Props) => {
  const { text, testId, cards } = props
  const translate = useTranslate()
  const { track } = useTracking()

  const handleOnLinkClick = (linkUrl: string) => {
    track(
      clickEvent({
        screen: 'no_changes_to_taxes',
        target: 'hyperlink',
        targetDetails: `questions_link__${linkUrl}`,
      }),
    )
  }

  const renderLink = (linkText: string, index: number, textIdPrefix: string) => {
    return (
      <a
        key="link"
        href={Links[index]}
        onClick={() => handleOnLinkClick(Links[index])}
        data-testid={`${textIdPrefix}--hyperlink-${index}`}
      >
        {translate(linkText)}
      </a>
    )
  }

  return (
    <section className="secondhand-taxes__questions-section" data-testid={testId}>
      <h2 className="secondhand-taxes__questions-section-title">{translate(text.title)}</h2>
      <div className="secondhand-taxes__questions-section-inner">
        {cards.map((card, index) => (
          <div key={index} className="secondhand-taxes__questions-section-card">
            <div className="secondhand-taxes__questions-section-card-image">
              <Image
                src={card.image.src}
                srcset={card.image.srcSet}
                scaling={Image.Scaling.Cover}
                loading="lazy"
                alt={card.title}
              />
            </div>
            <p className="secondhand-taxes__questions-section-card-title">
              {translate(card.title)}
            </p>
            <p className="secondhand-taxes__questions-section-card-description">
              {translate(card.description, { link: renderLink(card.link, index, testId) })}
            </p>
          </div>
        ))}
      </div>
    </section>
  )
}

export default QuestionsSection
